export default "__VITE_ASSET__ed4820c7__"